import { ButtonModule } from './../button/button.module';
import { SharedModule } from './../../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SacPurposeComponent } from './components/sac-purpose/sac-purpose.component';
import { SacPurposeDialogComponent } from './components/sac-purpose-dialog/sac-purpose-dialog.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [SacPurposeComponent, SacPurposeDialogComponent],
  imports: [
    CommonModule,
    SharedModule,
    ButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    MatDialogModule
  ],
  exports: [
    SacPurposeComponent,
    SacPurposeDialogComponent
  ]
})
export class SacPurposeModule { }
